import request from '../../../helper/NetworkLayer';

export function certificateRequest(issueId) {
  return request(
    '/learnerCertificate',
    {
      method: 'GET',
      headers: {
        'Content-type': 'application/json; charset=utf-8'
      }
    },
    {
      queryParams: {
        issueId,
        includeArray: '[user,company,state]'
      }
    }
  );
}

export function badgeRequest(issueId) {
  return request(
    '/learnerBadge',
    {
      method: 'GET',
      headers: {
        'Content-type': 'application/json; charset=utf-8'
      }
    },
    {
      queryParams: {
        issueId
      }
    }
  );
}
